<template>
  <div class="experts-feedback-block__container">
    <div class="experts-feedback-block">
      <BasicSection appearance="same-paddings">
        <h2 class="experts-feedback-block__title">Оцените раздел «Эксперты»</h2>
        <button
          title="Закрыть баннер"
          class="experts-feedback-block__close mq-mobile-only"
          @click="cancelBlock"
        >
          <SvgIcon icon="cross" size="16" />
        </button>
        <div class="experts-feedback-block__form">
          <RatingStarsForm
            :disabled="isLoading"
            :fixed="!!score"
            :value="score"
            @vote="openModal"
          />
          <BasicButton
            appearance="link"
            size="m"
            @click="cancelBlock"
            class="mq-not-mobile"
          >
            Оценить позже
          </BasicButton>
        </div>
      </BasicSection>
      <FeedbackModal
        :visible="!!score"
        title="Оценка сервиса «Эксперты»"
        :action="feedbackAction"
        :show-score="false"
        :chosen-score="score"
        @close="closeModal"
      />
    </div>
  </div>
</template>

<script>

  import { handleRequestError } from 'src/services/api.js';
  import { ExpertsService } from 'src/services/experts.js';

  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import FeedbackModal from 'src/components/FeedbackModal/FeedbackModal.vue';
  import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
  import RatingStarsForm from 'src/components/RatingStarsForm/RatingStarsForm.vue';
  import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';

  export default {
    name: 'ExpertsFeedbackBlock',
    components: {
      FeedbackModal,
      RatingStarsForm,
      BasicButton,
      BasicSection,
      SvgIcon
    },
    emits: ['hide'],
    data() {
      return {
        cancelled: false,
        showMessage: false,
        isLoading: false,
        score: null,
        modalVisible: false,
      }
    },
    methods: {
      feedbackAction: ExpertsService.sendFeedback,
      openModal(score) {
        this.score = score;
      },
      closeModal(voted) {
        this.score = null;
        if (voted) {
          this.$emit('hide');
        }
      },
      cancelBlock() {
        this.runAction(
          ExpertsService.sendFeedback,
          { refused: true },
        ).then(() => {
          this.$emit('hide');
        });
      },
      runAction(action, params) {
        this.isLoading = true;

        return action(params)
          .then(() => {
            this.showMessage = true;
          })
          .catch(handleRequestError)
          .finally(() => {
            this.isLoading = false;
          });
      }
    }
  };
</script>
